<template>
  <section>
    <Title :title-name="pageTitle" :title-link="title.PaxContactConfirm.titleLink" />
    <div
      v-if="lang && lang['combine_passengers'] && pax && PaxsGroup.length"
      class="pax_contact_confirm pax-contact-confirm__custom"
    >
      <div class="select_service pb20">
        <div class="container">
          <div class="mt-4">
            <ItemOfVouchers icon="contact-detail" color="#a7116f" :label="lang['combine_passengers'].SFS_LANG_ROW_1" border />
          </div>
          <div class="contact-ask mt-4">
            <div class="ws-textbox">
              <div>
                {{ lang['combine_passengers'].SFS_LANG_ROW_2 }}
              </div>
              <div class="d-flex">
                <div :class="[direction == 'rtl' ? 'ml-4 contact-ask-check' : 'mr-4']">
                  <label for="yes" class="mr-2">
                    {{ lang['combine_passengers'].SFS_LANG_ROW_3 }}
                  </label>
                  <input id="yes" v-model="answer" type="radio" value="yes" />
                </div>
                <div :class="[direction == 'rtl' ? 'mr-4 contact-ask-check' : 'ml-4']">
                  <label for="no" class="mr-2">
                    {{ lang['combine_passengers'].SFS_LANG_ROW_4 }}
                  </label>
                  <input id="no" v-model="answer" type="radio" value="no" />
                </div>
              </div>
            </div>
            <div v-show="answer === 'no'" class="ws-textbox mt-4">
              {{ lang['combine_passengers'].SFS_LANG_ROW_5 }}:
              <form id="invitePaxForm">
                <div v-for="(pax, index) in invitePaxs" :key="index" class="mt-3">
                  <div class="title-size d-flex justify-content-between">
                    <span>{{ lang['combine_passengers'].SFS_LANG_ROW_6 }} {{ index + 1 }}</span>
                    <span v-if="index != 0" class="cursor-pointer" @click="removeInvitePax(pax)"
                      ><i class="fas fa-times"></i
                    ></span>
                  </div>
                  <div class="text-center">
                    <button
                      v-if="airline && airline.params && !!parseInt(airline.params.enable_scan_boarding_pass)"
                      type="button"
                      class="ws-btn hd-normal-btn-background-color hd-normal-btn-color mt-3"
                      @click="openCameraScanBoardingPass(index)"
                    >
                      {{ lang['combine_passengers'].SFS_LANG_ROW_7 }}
                    </button>
                  </div>
                  <label>
                    {{ lang['combine_passengers'].SFS_LANG_ROW_8 }}
                    <span class="text-booking-reference">({{ lang['combine_passengers'].SFS_LANG_ROW_9 }})</span>
                  </label>
                  <input
                    v-model="pax.pnr"
                    class="input-name input-invite"
                    required
                    :class="{ 'check-valid': isSubmitForm }"
                    :maxlength="maxPnrLength"
                  />
                  <label>{{ lang['combine_passengers'].SFS_LANG_ROW_10 }}</label>
                  <input
                    v-model="pax.firstName"
                    class="input-name input-invite"
                    required
                    :class="{ 'check-valid': isSubmitForm }"
                    @input="pax.firstName = pax.firstName.toLocaleUpperCase()"
                  />
                  <label>{{ lang['combine_passengers'].SFS_LANG_ROW_11 }}</label>
                  <input
                    v-model="pax.lastName"
                    class="input-name input-invite"
                    required
                    :class="{ 'check-valid': isSubmitForm }"
                    @input="pax.lastName = pax.lastName.toLocaleUpperCase()"
                  />
                </div>
              </form>
              <span class="add-another-pax" @click="addInvitePax">
                {{ lang['combine_passengers'].SFS_LANG_ROW_12 }}
              </span>
              <b-modal
                id="modal-popup-open-camera"
                centered
                hide-footer
                hide-header
                no-close-on-backdrop
                class="border-0"
                :title="'Scan boarding pass'"
                size="lg"
              >
                <div id="reader" width="600px"></div>
                <div class="mt-3 text-center">
                  <button
                    type="button"
                    class="ws-btn hd-normal-btn-background-color hd-normal-btn-color"
                    @click="closeOrStopScanBoarding()"
                  >
                    <i class="fas fa-times"></i>
                    Close scan
                  </button>
                </div>
              </b-modal>
            </div>
            <div class="text-center mt-4" :class="{ 'contact-ask__button': answer === 'yes' }">
              <button type="button" class="ws-btn hd-normal-btn-background-color hd-normal-btn-color" @click="sendInvitePaxs">
                {{ lang['combine_passengers'].SFS_LANG_ROW_13 }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-alert
      v-model="showTop"
      class="position-fixed fixed-top m-0 rounded-0"
      style="z-index: 2000; border-radius: 1rem !important; border: 1px solid #ffa5a5; color: #444"
      variant="danger"
      dismissible
    >
      <div>{{ messageError }}</div>
    </b-alert>
  </section>
</template>

<script>
import { Html5Qrcode } from 'html5-qrcode'
import '@/assets/scss/modules/PaxContactConfirm.scss'
import Title from '@/components/Title/index'
import ItemOfVouchers from '@/components/ItemOfVouchers/index'

export default {
  name: 'InviteTravelTogether',
  components: {
    Title,
    ItemOfVouchers
  },
  props: {
    secret: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      stopInitRoute: false,
      alertConfirmPax: false,
      curPaxInfo: null,
      curPaxID: null,
      triggerTravelTogether: false,
      isSubmitForm: false,
      invitation_key: 0,
      invitePaxs: [
        {
          pnr: '',
          firstName: '',
          lastName: ''
        }
      ],
      invitePaxsGroup: [],
      invitePaxsTotal: [],
      answer: 'yes',
      showTop: false,
      messageError: '',
      html5Qrcode: '',
      cameraStatus: false,
      codeQrReaded: '',
      scanningPaxNumber: 0
    }
  },
  computed: {
    pageTitle() {
      const { lang } = this
      return lang && lang.hotel_mobile_new && this.lang.hotel_mobile_new.SFS_LANG_ROW_28
        ? lang.hotel_mobile_new.SFS_LANG_ROW_28
        : 'Home'
    },
    maxPnrLength() {
      if (this.airline?.params?.enable_limit_character_pnr == 1) {
        return 6
      }

      return null // unlimited
    }
  },
  watch: {
    PaxsGroup: function () {
      this.checkPermission()
    },
    pax: function () {
      this.checkPermission()
    },
    airline: function () {
      this.checkPermission()
    }
  },
  created() {
    this.checkPermission()
    document.addEventListener('focusin', this.focusChanged)
  },
  beforeUnmount() {
    document.removeEventListener('focusin', this.focusChanged)
  },
  methods: {
    checkPermission() {
      if (this.stopInitRoute || _.isEmpty(this.PaxsGroup) || _.isEmpty(this.airline) || _.isEmpty(this.pax)) {
        return
      }
      // Create main params
      this.initParams()
      // Disabled invite travel together
      if (this.airline.params.mobile_enable_travelcompanions_home == 0 || !this.isEnabledConfig('SFS_LANG_ROW_9')) {
        this.$router.push({ path: 'home', query: { secret: this.secret } })
      }

      // Go with group and not confirm name
      if (!this.curPaxInfo && this.PaxsGroup.length > 1) {
        this.$router.push({ path: 'contact-pax-confirm', query: { secret: this.secret } })
      }

      // Check condition for routing invite travel together
      this.checkWaiting()
      this.stopInitRoute = true
    },
    initParams() {
      var self = this
      // Check if go passenger go alone
      if (this.PaxsGroup.length == 1) {
        this.pax.curPaxID = this.curPaxID = this.pax.id
      } else {
        this.pax.curPaxID = this.curPaxID = this.$cookie.get('curPaxID' + this.pax.group_id)
      }
      this.curPaxInfo = _.find(this.PaxsGroup, function (obj) {
        return obj.passenger_id == self.pax.curPaxID
      })
    },
    focusChanged(event) {
      if (!_.isEmpty(event.target.id)) {
        this.invitation_key = parseInt(event.target.id)
      }
    },
    checkWaiting() {
      var self = this
      this.$store.dispatch('PaxContactConfirm/reFetchPaxGroup').then(function () {
        let temp = _.find(self.PaxsGroup, { passenger_id: self.pax.curPaxID })
        if (temp) {
          _.extend(self.pax, temp)
        }
        // Check if group is waiting reply from other passenger whom were invited
        _.some(self.PaxsGroup, function (pax) {
          if (_.isArray(pax.params.travel_together)) {
            let isWaitingReply = _.some(pax.params.travel_together, function (obj) {
              return obj.confirm_travel_together === ''
            })
            if (isWaitingReply) {
              self.$router.push({ path: 'passenger-invite-list', query: { secret: self.secret } })
            }
            // Return to stop process
            return isWaitingReply
          }
        })
      })
    },
    isEnabledConfig(key) {
      let row = _.find(this.airline.lang_config.pax_info.CONFIG, { key: key })
      return !_.isUndefined(row) ? row.enabled : false
    },
    checkForm(formId) {
      this.isSubmitForm = true
      let invalidObj = this.$el.querySelector(`${formId} *:invalid`)
      if (invalidObj) {
        invalidObj.focus()
        return false
      }
      return true
    },
    addInvitePax() {
      this.invitePaxs.push({
        pnr: '',
        firstName: '',
        lastName: ''
      })
      this.isSubmitForm = false
    },
    removeInvitePax(pax) {
      this.invitePaxs = _.without(this.invitePaxs, pax)
    },
    sendInvitePaxs() {
      if (this.answer === 'yes') {
        this.$router.push({ path: '/home', query: { secret: this.secret } })
        return
      }
      if (!this.checkForm('#invitePaxForm')) {
        return
      }
      if (_.isEmpty(this.invitePaxsGroup)) {
        this.PaxsGroup.forEach((value, index) => {
          if (value.passenger_id != this.curPaxID) {
            this.invitePaxsGroup.push({ firstName: value.first_name, lastName: value.last_name, pnr: value.pnr })
          }
        })
      }
      this.invitePaxsTotal = [...this.invitePaxsGroup, ...this.invitePaxs]
      let dataSend = {
        secret: this.secret,
        passengers: this.invitePaxsTotal,
        cur_pax_id: this.curPaxID
      }
      let self = this
      this.$store
        .dispatch('InviteTravelTogether/handleModifyGroupPax', dataSend)
        .then((res) => {
          if (res.success) {
            self.$store.dispatch('Home/getPaxsGroup').then(() => {
              self.$router.push({ path: '/passenger-detail', query: { secret: self.secret } })
            })
            self.$el.querySelector('#invitePaxForm input').focus()
          } else {
            self.showTop = true
            if (res.message === 'Action falied.') {
              self.messageError = 'We could not find the passenger on your flight'
            } else {
              self.messageError = res.message
            }
          }
        })
        .catch((e) => {
          console.log(e)
          self.showTop = true
          self.messageError = 'Action falied'
        })
    },
    setupHtml5Qrcode() {
      const html5QrCode = new Html5Qrcode('reader')
      const config = { fps: 10, qrbox: { width: 400, height: 400 } }
      const qrCodeSuccessCallback = (decodedText, decodedResult) => {
        console.log(`Code matched = ${decodedText}`, decodedResult)
        if (decodedResult.result) {
          this.codeQrReaded = decodedResult.decodedText || ''
          this.stopScanWhenHasCodeQr()
        }
      }
      html5QrCode.start({ facingMode: 'environment' }, config, qrCodeSuccessCallback).then(() => {
        this.cameraStatus = true
      })
      this.html5Qrcode = html5QrCode
    },
    openCameraScanBoardingPass(index) {
      this.codeQrReaded = ''
      this.scanningPaxNumber = index
      this.$bvModal.show('modal-popup-open-camera')
      if (this.answer !== 'no') return

      if (document.getElementById('modal-popup-open-camera') && document.getElementById('reader')) {
        this.setupHtml5Qrcode()
        return
      }

      setTimeout(() => {
        this.setupHtml5Qrcode()
      }, 1000)
    },
    closeOrStopScanBoarding() {
      if (this.cameraStatus) {
        this.html5Qrcode
          .stop()
          .then((ignore) => {
            // QR Code scanning is stopped.
            this.html5Qrcode.clear()
            this.cameraStatus = false
            this.$bvModal.hide('modal-popup-open-camera')
          })
          .catch((err) => {
            // Stop failed, handle it.
            console.log('err', err)
          })
      } else {
        this.$bvModal.hide('modal-popup-open-camera')
      }
    },
    stopScanWhenHasCodeQr() {
      this.closeOrStopScanBoarding()
      if (!this.codeQrReaded) {
        console.log('scan fail')
        return
      }
      this.handleCallApiReadCodeQr()
    },
    handleCallApiReadCodeQr() {
      let self = this
      if (!_.isEmpty(self.codeQrReaded)) {
        self.$store
          .dispatch('InviteTravelTogether/cuteScanStrToPax', self.codeQrReaded)
          .then((response) => {
            if (response.success && !_.isEmpty(response.data)) {
              self.invitePaxs[self.scanningPaxNumber].pnr = response.data.pnr
              self.invitePaxs[self.scanningPaxNumber].lastName = response.data.last_name
              self.invitePaxs[self.scanningPaxNumber].firstName = response.data.first_name
            }
          })
          .catch((err) => {
            // Stop failed, handle it.
            console.log('err', err)
          })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.error-message {
  color: red;
}
.title-size {
  font-size: 20px;
  color: #707070;
}
.vue-tel-input {
  border: 0;
}
.check-valid:invalid {
  border: red 1px solid;
}

.text-booking-reference {
  font-size: 14px;
}

.add-another-pax {
  text-decoration: underline;
  font-size: 16px;
  cursor: pointer;
}
.contact-ask__button {
  margin-top: 280px !important;
}
::v-deep .modal-backdrop {
  opacity: 0.5;
  background-color: #000 !important;
}

.contact-ask .contact-ask-check {
  direction: ltr;
}
</style>
